module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrMedium.c7393c1.woff";